import React from 'react'
import PropTypes from 'prop-types'
import {Box, AccordionItem, AccordionButton, AccordionPanel, useStyleConfig} from '@chakra-ui/react'
import {AddIcon, MinusIcon} from '../../../icons'
import {remCalc} from '../../../../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import AccordionList from './accordion-list'
import SanitizedHtml from '../../../html-sanitizer'

const AccordionItemBlock = ({
    item,
    isAccordionList,
    hasBigFontSize,
    hasSecondaryTitle,
    contrasted,
    smallGap = false,
}) => {
    const styles = useStyleConfig('Accordion')

    if (!item || Object.keys(item).length === 0) return null

    return (
        <AccordionItem
            {...styles.item}
            {...(contrasted
                ? {
                      backgroundColor: 'background.light',
                      marginBottom: smallGap ? remCalc(8) : remCalc(16),
                      border: 'none',
                  }
                : {
                      borderBottom: 'small',
                      borderStyle: 'solid',
                      borderColor: 'border.light',
                  })}
        >
            {({isExpanded}) => (
                <>
                    <AccordionButton data-testid="accordion-button" alignItems="center">
                        <Box
                            {...styles.accordionButtonTitle}
                            {...(hasSecondaryTitle && {maxW: remCalc(200)})}
                            sx={
                                hasBigFontSize
                                    ? styles.accordionButtonParagraphStyle
                                    : styles.accordionButtonTitleStyle
                            }
                        >
                            {item?.accordion_title || item?.summary}
                        </Box>
                        {!isExpanded && hasSecondaryTitle && (
                            <Box {...styles.accordionButtonTextDesktop}>
                                {item?.secondary_title}
                            </Box>
                        )}
                        <Box
                            transform={isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}
                            {...styles.iconBox}
                        >
                            {isExpanded ? (
                                <MinusIcon {...styles.iconBox} data-testid="minus-icon" />
                            ) : (
                                <Box {...styles.addIconBox}>
                                    <AddIcon {...styles.iconBox} data-testid="add-icon" />
                                </Box>
                            )}
                        </Box>
                    </AccordionButton>
                    {!isExpanded && hasSecondaryTitle && (
                        <Box {...styles.accordionButtonTextMobile}>{item?.secondary_title}</Box>
                    )}
                    <AccordionPanel data-testid="accordion-content">
                        {isAccordionList ? (
                            <AccordionList lists={item?.values} />
                        ) : (
                            <SanitizedHtml
                                as={Box}
                                html={item?.paragraph || item?.details}
                                {...styles.accordionPanelText}
                                sx={{
                                    '.videoWrapper': {
                                        position: 'relative',
                                        width: '100%',
                                        aspectRatio: '16 / 9',
                                        height: 'auto',
                                    },
                                }}
                            />
                        )}
                    </AccordionPanel>
                </>
            )}
        </AccordionItem>
    )
}

AccordionItemBlock.propTypes = {
    item: PropTypes.object,
    isAccordionList: PropTypes.bool,
    hasBigFontSize: PropTypes.bool,
    hasSecondaryTitle: PropTypes.bool,
    contrasted: PropTypes.bool,
    smallGap: PropTypes.bool,
}

export default AccordionItemBlock
